interface ArticleSchemaProps {
  slug: string;
  title: string;
  description: string;
  datePublished?: string;
  dateModified?: string;
  wordCount?: number;
}

export default function ArticleSchema({
  slug,
  title,
  description,
  datePublished = '2026-06-25',
  dateModified = '2026-06-25',
  wordCount = 1200,
}: ArticleSchemaProps) {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.boutique';
  const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    author: {
      '@type': 'Organization',
      name: 'Hoobuy Boutique',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Hoobuy Boutique',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
    datePublished,
    dateModified,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteUrl}/artigo/${slug}`,
    },
    image: logoUrl,
    inLanguage: 'pt-PT',
    wordCount,
    isPartOf: {
      '@type': 'WebSite',
      name: 'Hoobuy Boutique',
      url: siteUrl,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}